module.exports = __webpack_public_path__ + "img/bg-img-footer.27ed529c.svg";